'use client';

import { IconInfoCircle } from '@tabler/icons-react';
import { OrderWorkProofMechanism } from 'database';
import { useTranslations } from 'i11n';
import { Alert, AlertDescription } from 'ui';

/**
 * Reporte XOR Inspección — explica por qué esta sección está en modo consulta.
 *
 * Las pestañas de los dos mecanismos siguen visibles siempre (el historial se
 * puede mirar), pero solo una de ellas es utilizable. Sin este aviso, la que no
 * corresponde se ve como una sección vacía y rota en vez de una que no aplica.
 *
 * `section` es el mecanismo que la pestaña representa; se renderiza solo cuando
 * NO coincide con el de la orden.
 */
export const OrderProofMechanismNotice = ({
  mechanism,
  section,
}: {
  // El mecanismo de la orden (`Order.work_proof_mechanism`). Es inmutable desde
  // el alta, así que leerlo del contexto SSR es seguro.
  mechanism: OrderWorkProofMechanism;
  section: OrderWorkProofMechanism;
}) => {
  const t = useTranslations('orders.mechanism.notice');

  if (mechanism === section) return null;

  return (
    <Alert>
      <IconInfoCircle className='h-4 w-4' />
      <AlertDescription className='text-sm'>{t(mechanism)}</AlertDescription>
    </Alert>
  );
};
